// Step 18 — AI header.
//
// Shows current workspace + deal status when a workspace is resolved
// (either via URL param or the server-selected active_workspace). When
// no workspace exists yet, renders an unobtrusive breadcrumb of
// "Ingen affär vald".

import { useAIWorkspace } from "./AIWorkspaceContext";

const DEAL_STATUS_LABEL = {
  pending: "Aktivering väntar",
  active: "Aktiv",
  closing: "Stängs",
  closed: "Stängd",
  archived: "Arkiverad",
};

export default function AIHeader() {
  const { activeWorkspace, loading } = useAIWorkspace();

  return (
    <header className="qai-shell-header">
      <div className="qai-shell-header-left">
        {loading ? (
          <span className="qai-shell-header-meta">Laddar…</span>
        ) : activeWorkspace ? (
          <>
            <span className="qai-shell-header-workspace">
              {activeWorkspace.organisation_name}
            </span>
            {activeWorkspace.deal_stage && (
              <span className="qai-shell-header-stage">
                {activeWorkspace.deal_stage}
              </span>
            )}
            {activeWorkspace.deal_status && (
              <span
                className="qai-shell-header-status"
                data-status={activeWorkspace.deal_status}
              >
                {DEAL_STATUS_LABEL[activeWorkspace.deal_status] ||
                  activeWorkspace.deal_status}
              </span>
            )}
          </>
        ) : (
          <span className="qai-shell-header-meta">Ingen affär vald</span>
        )}
      </div>
    </header>
  );
}
